module.exports = __webpack_public_path__ + "assets/e3f5bb1c80b6abb919c667408fb8317a.mp3";